import gql from 'graphql-tag';

const SpaceDirectorySpaceFragment = gql`
	fragment SpaceDirectorySpaceFragment on Space {
		alias @include(if: $includeAlias)
		id
		name
		key
		icon {
			path
			isDefault
		}
		currentUser @include(if: $isLicensed) {
			isAdmin
			isFavourited
			isWatched
		}
		type
		status
		metadata {
			labels {
				nodes {
					id
					name
					prefix
				}
			}
		}
		description {
			plain {
				value
			}
		}
	}
`;

export const SpaceQuery = gql`
	query SpaceForMockQuery(
		$spaceKey: String!
		$isLicensed: Boolean!
		$includeAlias: Boolean = false
	) {
		space(key: $spaceKey) {
			...SpaceDirectorySpaceFragment
		}
	}
	${SpaceDirectorySpaceFragment}
`;

export const SpaceDirectorySpacesQuery = gql`
	query SpaceDirectorySpacesQuery(
		$name: String
		$type: String
		$excludeTypes: String
		$status: String
		$label: [String]
		$watching: Boolean
		$favourite: Boolean
		$offset: Int
		$first: Int
		$isLicensed: Boolean!
		$includeAlias: Boolean = false
	) {
		spaces(
			spaceNamePattern: $name
			type: $type
			excludeTypes: $excludeTypes
			status: $status
			label: $label
			watchedSpacesOnly: $watching
			favourite: $favourite
			offset: $offset
			first: $first
		) {
			nodes {
				...SpaceDirectorySpaceFragment
			}
			pageInfo {
				hasNextPage
				endCursor
			}
		}
	}

	${SpaceDirectorySpaceFragment}
`;

const SpaceDropdownSpaceFragment = gql`
	fragment SpaceDropdownSpaceFragment on Space {
		id
		name
		key
		icon {
			path
		}
	}
`;

export const SpaceDirectoryStarredSpacesQuery = gql`
	query SpaceDirectoryStarredSpacesQuery {
		spaces(favourite: true, first: 99, status: "current") {
			nodes {
				...SpaceDropdownSpaceFragment
			}
		}
	}
	${SpaceDropdownSpaceFragment}
`;
